<template>
  <div class="nav-wrapper">
    <div class="experience-container">
      <div class="form-section">
        <div class="business-form">
          <BackButton @back="$emit('back')" />
          <h1 class="main-title">{{ $t('businessAddress.title') }}</h1>

          <div class="experience-options">
            <label class="experience-option" :class="{ 'selected': differentAddress === false }">
              <input type="radio" v-model="differentAddress" :value="false" class="radio-input">
              <span class="radio-custom"></span>
              <span class="option-text">{{ $t('businessAddress.options.no') }}</span>
            </label>

            <label class="experience-option" :class="{ 'selected': differentAddress === true }">
              <input type="radio" v-model="differentAddress" :value="true" class="radio-input">
              <span class="radio-custom"></span>
              <span class="option-text">{{ $t('businessAddress.options.yes') }}</span>
            </label>
          </div>

          <!-- New Address Form -->
          <div v-if="differentAddress" class="address-form">
            <div class="form-row">
              <div class="form-group half">
                <label>{{ $t('businessAddress.form.street.label') }}</label>
                <input type="text" v-model="businessAddress.street" :placeholder="$t('businessAddress.form.street.placeholder')"
                  class="form-input" />
              </div>

              <div class="form-group half">
                <label>{{ $t('businessAddress.form.city.label') }}</label>
                <input type="text" v-model="businessAddress.city" :placeholder="$t('businessAddress.form.city.placeholder')" class="form-input" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group half">
                <label>{{ $t('businessAddress.form.state.label') }}</label>
                <select v-model="businessAddress.state" class="form-select custom-select">
                  <option value="" disabled selected>{{ $t('businessAddress.form.state.placeholder') }}</option>
                  <option v-for="state in states" :key="state" :value="state">
                    {{ state }}
                  </option>
                </select>
              </div>

              <div class="form-group half">
                <label>{{ $t('businessAddress.form.zipCode.label') }}</label>
                <input type="text" v-model="businessAddress.zipCode" :placeholder="$t('businessAddress.form.zipCode.placeholder')" class="form-input" />
              </div>
            </div>
          </div>

          <button class="next-button" @click="handleNext">{{ $t('businessAddress.next') }}</button>
          <button class="skip-button" @click="$emit('skip')">{{ $t('businessAddress.skip') }}</button>
        </div>
      </div>
      <div class="image-section">
        <img src="@/assets/slider4.png" alt="Productive workspace with laptop" class="main-image">
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from './BackButton.vue'

export default {
  name: 'BusinessAddress',
  components: {
    BackButton
  },
  data() {
    return {
      differentAddress: false,
      businessAddress: {
        street: '',
        city: '',
        state: '',
        zipCode: '',
        country: ''
      },
      states: ['Utah']
    }
  },
  methods: {
    handleNext() {
      this.$emit('next', {
        differentAddress: this.differentAddress,
        businessAddress: this.businessAddress
      });
    }
  }
}
</script>

<style scoped>
@import '@/styles/CustomerBusiness.css';
</style> 